import React, { useState } from 'react';
import DetailsofProfile from '../../ProfileDetails/DetailsofProfile';
import DetailsofAddress from '../AddressDetails/DetailsofAddress';
import EducationdetailsofProfile from '../EducationDetails/EducationdetailsofProfile';
import ExperiencedetailsofProfile from '../ExperienceDetails/ExperiencedetailsofProfile';
import './ProfilesforInterview.css';

const ProfilesForInterview = () => {
  const [activeSection, setActiveSection] = useState('details');

  const handleNext = () => {
    if (activeSection === 'details') setActiveSection('address');
    else if (activeSection === 'address') setActiveSection('education');
    else if (activeSection === 'education') setActiveSection('experience');
  };

  const handlePrevious = () => {
    if (activeSection === 'experience') setActiveSection('education');
    else if (activeSection === 'education') setActiveSection('address');
    else if (activeSection === 'address') setActiveSection('details');
  };

  return (
    <React.Fragment>
      <div className="profilesforinterview-container">
        <nav className="profilesforinterview-navbar">
          <ul className="navbar-list">
            <li onClick={() => setActiveSection('details')} className={activeSection === 'details' ? 'active' : ''}>
              Details
            </li>
            <li onClick={() => setActiveSection('address')} className={activeSection === 'address' ? 'active' : ''}>
              Address
            </li>
            <li onClick={() => setActiveSection('education')} className={activeSection === 'education' ? 'active' : ''}>
              Education
            </li>
            <li onClick={() => setActiveSection('experience')} className={activeSection === 'experience' ? 'active' : ''}>
              Experience
            </li>
          </ul>
        </nav>

        <div className="profilesforinterview-content">
          {activeSection === 'details' && <DetailsofProfile onNext={handleNext} />}
          {activeSection === 'address' && <DetailsofAddress onNext={handleNext} onPrevious={handlePrevious} />}
          {activeSection === 'education' && <EducationdetailsofProfile onNext={handleNext} onPrevious={handlePrevious} />}
          {activeSection === 'experience' && <ExperiencedetailsofProfile onPrevious={handlePrevious} />}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProfilesForInterview;
